import type { Capsule } from '../types';
import { capsuleProtection } from '../lib/protection';

/**
 * Capsule status pill. The Odoo record status "sealed" only means "recorded";
 * it is shown as what the payload really is — "compressed" or "encrypted"
 * (decision D-3 A). Other statuses (draft / active / destroyed) are shown as is.
 */
export function StatusPill({ capsule }: { capsule: Pick<Capsule, 'status' | 'pqc_algorithm'> }) {
  if (capsule.status === 'sealed') {
    const p = capsuleProtection(capsule.pqc_algorithm);
    return (
      <span className="pill pill-sealed" title={`${p.description} Imperio record status: sealed.`}>
        {p.label}
      </span>
    );
  }
  return <span className={`pill pill-${capsule.status}`}>{capsule.status}</span>;
}
